import { nanoid } from 'nanoid'
import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState: {
  isDialogOpen: boolean
  messages: { id: string; text: string }[]
} = {
  isDialogOpen: false,
  messages: [],
}

export default handleActions<typeof defaultState, any>(
  {
    [rawActions.openInfoMessageDialog.toString()](state, { payload }) {
      if (payload) {
        const addedMessage = {
          id: nanoid(),
          text: payload,
        }
        return { isDialogOpen: true, messages: [...state.messages, addedMessage] }
      }
      return { ...state, isDialogOpen: true }
    },
    [rawActions.closeInfoMessageDialog.toString()](state, { payload }) {
      const removedMessage = payload

      return { isDialogOpen: false, messages: state.messages.filter((mes) => mes.id !== removedMessage.id) }
    },
    [rawActions.resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
